<template>
    <div class="header-box">
        <div class="logo-box">
            <el-image style=" height: 32px" :src="logo"/>
        </div>
        <div class="header-right">
            <a target="_blank" href="/map" v-if="type!=='map'" class="map-btn">
                <i class="iconfont icon-ditu"></i>
                <span target="_blank" href="/map">地图搜索</span>
            </a>
            <div v-else>数据时间：{{ time }}</div>
            <div class="user-box">
                <span>{{ userName }}</span>
            </div>
            <div class="login-box-btn">
                <!--                <span @click="isshowModify=true">修改密码</span>-->
                <span @click="loginOut">退出登录</span>
            </div>
        </div>
        <div class="modify-password-box" v-if="isshowModify">
            <div class="modify-pwd-box">
                <p class="modify-text">密码修改</p>
                <div class="modify-box">
                    <div class="modify-error error" v-if="errMsg"><span><b>×</b></span><i class="error-cue">{{
                            errMsg
                        }}</i></div>
                    <div class="modify-input">
                        <span>登录账号：</span>
                        <input type="text" placeholder="请输入用户名" v-model="editParams.userName" maxlength="20"
                               disabled>
                    </div>
                    <div class="modify-input">
                        <span>登录密码：</span>
                        <input type="password" placeholder="请输入密码" v-model="editParams.password" maxlength="20">
                    </div>
                    <div class="modify-input">
                        <span>新密码：</span>
                        <input type="password" placeholder="请输入新密码" v-model="editParams.newPassword"
                               maxlength="20">
                    </div>
                    <div class="modify-input">
                        <span>确认新密码：</span>
                        <input type="password" placeholder="请输入确认密码" v-model="editParams.comfirmPassword"
                               maxlength="20">
                    </div>
                    <el-button type="primary" href="javascript:void(0);" class="btn-modify" v-on:click="modify()"
                               :disabled="disabled">确 定
                    </el-button>
                </div>
                <div class="close-user-box" @click="isshowModify=false">×</div>
            </div>

        </div>
    </div>
</template>

<script setup>
import logo from '@/assets/images/logo.png'
import {ref} from "vue";
import request from "@/service/request";

const userName = localStorage.getItem('userName')
const isshowModify = ref(false)
const props = defineProps({
    type: {
        type: String,
        default: ''
    }
})
let time = localStorage.getItem('time')

/**修改密码**/
const errMsg = ref('')
const disabled = ref(false)
const editParams = ref({
    userName: '',
    password: '',
    newPassword: '',
    comfirmPassword: ''
})

async function modify() {
    disabled.value = true
    if (!editParams.value.password) {
        errMsg.value = '请输入密码';
        disabled.value = false
        return;
    }
    if (!editParams.value.newPassword) {
        errMsg.value = '请输入新密码';
        disabled.value = false
        return;
    }
    if (!editParams.value.comfirmPassword) {
        errMsg.value = '请输入确认密码';
        disabled.value = false
        return;
    }
    if (editParams.value.newPassword !== editParams.value.comfirmPassword) {
        errMsg.value = '输入的新密码和确认密码不一致';
        disabled.value = false
        return;
    }

    try {
        let result = await request({
            url: `/system/user/profile/updatePwd?oldPassword=${editParams.value.password}&newPassword=${editParams.value.newPassword}`,
            method: 'put'
        })
        localStorage.removeItem("token");
        localStorage.removeItem("roleName");
        localStorage.removeItem("userName");
        location.href = "/login";
    } catch (e) {
        errMsg.value = e.data.msg;
        disabled.value = false
    } finally {
        disabled.value = false
    }
}

// 退出
const loginOut = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("roleName");
    localStorage.removeItem("userName");
    location.href = "/login";
}

</script>

<style lang="less" scoped>
@import '../../assets/css/login.css';

.header-box {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .logo-box {
        display: flex;
        align-items: center;

        .logo-text {
            display: inline-block;
            margin-left: 16px;
            padding-left: 16px;
            font-size: 16px;
            font-weight: bold;
            color: #FFFFFF;
            border-left: 1px solid #fff;
        }
    }

    .header-right {
        display: flex;
        align-items: center;
        font-size: 12px;
        font-weight: 400;
        flex: 1;
        color: #FFFFFF;
        justify-content: flex-end;
        position: relative;

        .map-btn {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 108px;
            height: 28px;
            background: #1477C9;
            border-radius: 14px;
            font-size: 14px;
            color: #FFFFFF;
            cursor: pointer;
            text-decoration: none;

            .icon-ditu {
                margin-right: 5px;
            }

            & > span {
                color: #FFFFFF;
            }
        }

        .user-box {
            padding: 0 48px;
            border-right: 2px solid #637AAD;
        }

        .login-box-btn {
            cursor: pointer;
            padding-right: 10px;

            span {
                padding-left: 40px;
            }

        }
    }

}

</style>